import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: {},
    tabBarActive: false,
    zones: [],
    zoneSelected: {},
    lastUserMovements: [],
    lastMovements: [],
  },
  getters: {
    getZones: state => {
      let zones = []
      state.zones.map(zone => {
        zones.push({
          id: zone.id,
          text: zone.geojson.properties.NOMOBJET,
          value: zone.geojson.properties.NOMOBJET,
          geojson: zone.geojson
        })
      })
      return zones
    },
    getTabBarActive: (state) => state.tabBarActive, // Getter pour accéder à tabBarActive
  },
  mutations: {
    setZoneSelected(state, zone) {
      let zoneSelected = state.zones.find(z => z.id == zone.id)
      state.zoneSelected = {
        id: zoneSelected?.id || null,
        text: zoneSelected.geojson.properties.NOMOBJET,
        value: zoneSelected.geojson.properties.NOMOBJET
      }
    },
    setZones(state, zones) {
      state.zones = zones
    },
    setLastUserMovements(state, movements) {
      state.lastUserMovements = movements
    },
    setLastMovements(state, movements) {
      state.lastMovements = movements
    },
    setToken(state, token) {
      localStorage.setItem('token', token)
      state.token = token
    },
    setUser(state, user) {
      state.user = user
    },
    TOGGLE_TAB_BAR(state) {
      state.tabBarActive = !state.tabBarActive;
    },
  },
  actions: {
    setZoneSelected({ commit }, zone) {
      commit('setZoneSelected', zone)
    },
    setZones({ commit }, zones) {
      commit('setZones', zones)
    },
    setLastUserMovements({ commit }, movements) {
      commit('setLastUserMovements', movements)
    },
    setLastMovements({ commit }, movements) {
      commit('setLastMovements', movements)
    },
    setToken({commit}, token) {
      commit('setToken', token)
    },
    setUser({commit}, user) {
      // console.log('set user', user)
      commit('setUser', user)
    },
    toggleTabBar({ commit }) {
      commit('TOGGLE_TAB_BAR');
    },
  },
  modules: {
  }
})
